const AUTH_LOCAL_STORAGE_KEY = 'accessToken'
const AUTH_LOCAL_STORAGE_USER_ROLE_KEY = 'userRoles'
const getAuth = (): string | undefined => {
  if (!sessionStorage) {
    return
  }

  const lsValue: string | null = sessionStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth = (lsValue) as string || ''
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: string) => {
  if (!sessionStorage) {
    return
  }

  try {
    const lsValue = auth
    sessionStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
    
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!sessionStorage) {
    return
  }

  try {
    sessionStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: { headers: { Authorization: string } }) => {
      const auth = getAuth()
      // if (auth) {
      //   config.headers.Authorization = auth
      // }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}

const getUserRole = () => {
  if (!sessionStorage) {
    return
  }
  const lsValue: string | null = sessionStorage.getItem(AUTH_LOCAL_STORAGE_USER_ROLE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth = JSON.parse(lsValue) as string
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH USER ROLE STORAGE PARSE ERROR', error)
  }
}

export {
  getAuth,
  setAuth,
  removeAuth,
  getUserRole,
  AUTH_LOCAL_STORAGE_KEY,
  AUTH_LOCAL_STORAGE_USER_ROLE_KEY,
}
